// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iI1KCjbBxfeB1BR_mG8kw","visible":"_1Jf84SPJ_USn1B9D6a1D8Y","cancelBtn":"_3QJSQPCPV_zXh-EfkLBslK","icon":"_2jsVT-eninuq_ifHQKByk","saveBtn":"_2988Xi6PWy-xCSbGhwBR-W"};